import React, { useEffect, useState, useRef, memo } from 'react';
import { isNil, startCase, replace, lowerCase as toLowerCase, sortBy } from 'lodash';
import { Box, CircularProgress, Typography } from '@mui/material';

import RoleMenuItem from './RoleItem';
import useStyles from './styles';

const getRoleLabel = (roleName) => (!isNil(roleName) ? startCase(toLowerCase(replace(roleName, /[\W]/g, ' '))) : 'Unknown Role');

const RolesSwitcher = memo(
  ({ initialRoles, currentRoles, isSwitchingRoles, handleRoleSwitch, switchingRolesError }) => {
    const classes = useStyles();
    const isFirstRender = useRef(true);

    const initialRoleUUIDs = initialRoles.map((role) => role.uuid);
    const [roles, setRoles] = useState(initialRoleUUIDs.filter((uuid) => currentRoles.some((role) => role.uuid === uuid)));

    const handleClick = (roleId) =>
      setRoles((prevState) => (prevState.includes(roleId) ? prevState.filter((id) => id !== roleId) : [...prevState, roleId]));

    // prevent submitting on first render
    useEffect(() => {
      if (!isFirstRender.current) {
        handleRoleSwitch(roles);
      }
    }, [roles]);

    useEffect(() => {
      isFirstRender.current = false;
    }, []);

    const rolesList = !isSwitchingRoles
      ? sortBy(initialRoles, 'roleName').map((role) => {
          const checked = roles.includes(role.uuid);
          const disabled = roles.length < 2 && checked;

          return (
            <RoleMenuItem
              key={role.roleName}
              role={role}
              classes={classes}
              getRoleLabel={getRoleLabel}
              disabled={disabled}
              checked={checked}
              handleClick={handleClick}
            />
          );
        })
      : null;

    return initialRoles ? (
      <Box display="flex" flexDirection="column" borderBottom="1px solid #fff" pb="5px" mb="10px" className="roles-switcher">
        <Typography className="sub-title">Access Levels</Typography>
        {isSwitchingRoles ? (
          <Box display="flex" alignItems="center" justifyContent="center" height="50px" width="100%">
            <CircularProgress color="primary" size="30px" />
          </Box>
        ) : null}
        {rolesList}
        {!isSwitchingRoles && switchingRolesError ? <Typography className={classes.errorMessage}>{switchingRolesError}</Typography> : null}
      </Box>
    ) : null;
  },
  (prevProps, nextProps) =>
    prevProps.initialRoles === nextProps.initialRoles &&
    prevProps.currentRoles === nextProps.currentRoles &&
    prevProps.isSwitchingRoles === nextProps.isSwitchingRoles &&
    prevProps.switchingRolesError === nextProps.switchingRolesError,
);

export default RolesSwitcher;
